/**
 * Navigation Configuration
 * Centralized menu structure for header navigation
 */

export interface SubMenuItem {
  /** Translation key (e.g., 'nav.aboutUs') or null if using label */
  key?: string
  /** Direct label text (used if key is not provided) */
  label?: string
  /** Navigation path */
  href: string
}

export interface MenuItem {
  /** Translation key for the menu item */
  key: string
  /** Navigation path for the main menu item */
  href: string
  /** Submenu items (null if no submenu) */
  submenu: SubMenuItem[] | null
}

/**
 * Main navigation menu structure
 * Edit this array to add/remove/modify menu items
 */
export const navigationMenu: MenuItem[] = [
  {
    key: 'nav.technology',
    href: '/technology',
    submenu: [
      { key: 'nav.howItWorks', href: '/technology/how-it-works' },
      { key: 'nav.htsIsotes', href: '/technology/hts' },
      { key: 'nav.iuIsotes', href: '/technology/iu' },
      { key: 'nav.hybridIsotes', href: '/technology/hybrid' },
      { key: 'nav.tesm', href: '/technology/tesm' },
      { key: 'nav.chargeDischarge', href: '/technology/charge-discharge' },
      { key: 'nav.standardCustom', href: '/technology/standard-custom' },
    ]
  },
  {
    key: 'nav.industries',
    href: '/applications',
    submenu: [
      { key: 'nav.industrial', href: '/applications/industrial' },
      { key: 'nav.residential', href: '/applications/residential' },
      { key: 'nav.grid', href: '/applications/grid' },
      { key: 'nav.smr', href: '/applications/smr' },
    ]
  },
  {
    key: 'nav.projects',
    href: '/projects',
    submenu: [
      { key: 'nav.project01mwhr', href: '/projects/0.1-mwhr' },
      { key: 'nav.project07mwhr', href: '/projects/0.7-mwhr' },
      { key: 'nav.koicaSeed1', href: '/projects/koica-cts-seed-1' },
      { key: 'nav.koicaSeed2', href: '/projects/koica-cts-seed-2' },
      { key: 'nav.deeptechTips', href: '/projects/deeptech-tips' },
    ]
  },
  {
    key: 'nav.blog',
    href: '/blog',
    submenu: null
  },
  {
    key: 'nav.about',
    href: '/company',
    submenu: [
      { key: 'nav.aboutUs', href: '/company/about' },
      { key: 'nav.partners', href: '/company/partners' },
      { key: 'nav.newsMedia', href: '/company/news' },
      { key: 'nav.career', href: '/company/career' },
      { key: 'nav.ir', href: '/ir' },
    ]
  },
  {
    key: 'nav.contact',
    href: '/contact',
    submenu: null
  }
]
